import axios from "axios";
import api from "@/api";
import { buildParams, formatArrayToElSelect, formatDate } from "@/utils";
import {
  BASE_NAVIXY_API_PANEL_URL,
  NAVIXY_PANEL_PASSWORD,
  NAVIXY_PANEL_USERNAME,
  BASE_NAVIXY_API_URL,
  USER_ID_NAVIXY_DEMO
} from "@/const";
import Vue from "vue";

const black_list = [
  "battery_off",
  "detach",
  "gps_lost",
  "gsm_damp",
  "lowpower",
  "offline",
  "poweroff"
];

const vue = new Vue();
const limitHistoyRange = 90;
// const hoursPassed = 12;

const state = {
  status: "",
  total_gps: 0,
  total_gps_by_user: 0,
  total_users: 0,
  sum_status_by_user: {},
  list: [],
  list_by_user: [],
  token: "",
  usersToken: {},
  panel_api_url: BASE_NAVIXY_API_PANEL_URL,
  api_url: BASE_NAVIXY_API_URL,
  current_user: {
    eventCollection: [],
    blackTrackers: []
  },
  model_list: [],
  trackers: [],
  tracker_history: [],
  f: Date.now(),
  t: Date.now(),
  reportUserNotContract: [],
  qtyOfEquipmentWithoutContract: 0,
  userList: [],
  Actualhash: Number,
  ActualUserList: [],
  ActualUserInfo: {},
  reportUserNotContract2: [],
  qtyOfEquipmentWiNAVNAV: 0
};

const getters = {
  isLoading: (state) => state.status === "loading",
  modelListToSelector: (state) =>
    formatArrayToElSelect(state.model_list, {
      label: "name",
      value: "code"
    }),
  getUserToken: (state) => (user_id) => state.userToken[user_id],
  getUserList: (state) => state.userList,

  getActualhash: (state) => state.Actualhash,
  getActualUserList: (state) => (ClientCode) => {
    return state.ActualUserList.filter(
      (user) => user.post_region === ClientCode
    );
  },
  getActualUserId: (state, getters) => (ClientCode) => {
    /*
    console.log("state: ", state, "\n getters: ", getters);
    console.log("ClienCode: ", ClientCode);

    console.log("\n getActualUserId: ",
      getters.getActualUserList(ClientCode)
    );
     */

    if (getters.getActualUserList(ClientCode).length > 0) {
      return getters.getActualUserList(ClientCode)[0].id;
    } else {
      return 1;
    }
  },
  getActualUserInfo: (state) => state.ActualUserInfo,

  getUserListByClientCode: (state) => state.userList,
  getTrackers: (state) => state.trackers,
  getReportGpsByCurrentUser: (state) => {
    const now = new Date();
    const itemsO = JSON.parse(JSON.stringify(state.list_by_user));
    const events = state.current_user.eventCollection;
    const eventIds = events.map((m) => m.tracker_id);
    let newItems = {
      list: [],
      count: 0
    };

    itemsO.forEach((item) => {
      if (eventIds.includes(item.id)) {
        const event = JSON.parse(
          JSON.stringify(events.find((f) => f.tracker_id === item.id))
        );
        const cEvent = new Date(event.time);
        let differenceTime = now.getTime() - cEvent.getTime();
        let differenceHours = (differenceTime / (1000 * 3600 * 24)) * 24;

        newItems.list.push({
          ...item,
          lastEvent: event,
          differenceHours: differenceHours
        });
      } else {
        newItems.list.push({
          ...item,
          lastEvent: {},
          differenceHours: 0
        });
      }

      newItems.count++;
    });

    return newItems;
  }
};

const actions = {
  getTotalGps: async ({ dispatch, commit }) => {
    try {
      const trackers = await dispatch("getTrackers");
      //console.log("trackers: " , trackers)
      let trackersfiltered = trackers.list.filter(
        (tracker) =>
          tracker.clone === false &&
          tracker.deleted === false &&
          tracker.source.blocked === false
      );
      //console.log("trackersfiltered: ")
      //console.log("trackersfiltered: " , trackersfiltered)
      commit("total_gps", trackersfiltered.length);
      commit("set_trackers", trackersfiltered);
      return trackersfiltered.length;
    } catch (error) {
      console.error(error);
      return Promise.reject(error);
    }
  },

  getTotalUsers: async ({ dispatch, commit }) => {
    try {
      const users = await dispatch("getUserList");
      commit("total_users", users.count);
      return users.count;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  getPanelToken: ({ state, commit }) => {
    return new Promise((resolve, reject) => {
      if (state.token) {
        resolve(state.token);
      } else {
        axios
          .post(state.panel_api_url + "account/auth", {
            login: NAVIXY_PANEL_USERNAME,
            password: NAVIXY_PANEL_PASSWORD
          })
          .then(({ data }) => {
            commit("token", data.hash);
            resolve(data.hash);
          })
          .catch((error) => {
            commit("error");
            reject(error);
          });
      }
    });
  },

  getUserToken: ({ dispatch, state, commit }, { user_id }) => {
    return new Promise((resolve, reject) => {
      if (state.usersToken[user_id] !== undefined) {
        resolve(state.usersToken[user_id]);
      } else {
        dispatch("request", {
          action: "user/session/create",
          params: {
            user_id: user_id
          },
          root: "hash"
        })
          .then((hash) => {
            commit("success");
            commit("usersToken", {
              user_id: user_id,
              token: hash
            });
            resolve(hash);
          })
          .catch((error) => {
            commit("error");
            reject(error);
          });
      }
    });
  },

  request: async (
    { dispatch, state, commit },
    { action, params, root, panel, user_id }
  ) => {
    panel = panel === undefined ? true : panel;

    let hash = "";

    if (panel) {
      hash = await dispatch("getPanelToken");
      commit("Set_Actualhash", hash);
    } else {
      let sId = user_id;

      if (sId === null || sId === undefined) {
        sId = state.current_user.id;
      }

      hash = await dispatch("getUserToken", {
        user_id: sId
      });
    }

    if (params === undefined) {
      params = {};
    }

    if (hash) {
      params["hash"] = hash;
    }
    const baseUrl = panel === true ? state.panel_api_url : state.api_url;

    return axios
      .post(`${baseUrl}${action}`, buildParams(params))
      .then((response) => {
        //console.log("response: ", response);
        let data = response.data;
        return root ? data[root] : data;
      });
  },
  getModelList: ({ dispatch, commit }) => {
    return new Promise((resolve, rejet) => {
      commit("loading");

      dispatch("getUserToken", {
        user_id: state.current_user.id
      }).then((token) => {
        dispatch("request", {
          action: `tracker/list_models?hash=${token}`,
          params: {
            hash: token
          },
          root: "list",
          panel: false
        })
          .then((data) => {
            commit("success");
            commit("model_list", data);
            resolve(data);
          })
          .catch((error) => {
            commit("error");
            rejet(error);
          });
      });
    });
  },

  getUserList: async ({ dispatch, state, commit }) => {
    //console.log("getUserList :", state);
    if (state.userList.length > 0) {
      return {
        count: state.userList.length,
        list: state.userList
      };
    }
    const users = await dispatch("request", {
      action: "user/list"
    });

    commit("SET_USER_LIST", users.list);

    return users;
  },

  async searchUserId(context, payload) {
    const users = await context.dispatch("request", {
      action: "user/list",
      params: {
        filter: payload.client_code
      }
    });

    let user = {};
    if (users.count === 0) {
      return -1;
    } else if (users.count === 1) {
      user = users.list[0];
    } else {
      user = users.list.filter((u) => u.post_region === payload.client_code)[0];
    }

    context.commit("current_user", {
      ...context.state.current_user,
      ...user
    });

    return user.id;
  },
  getTrackers: ({ dispatch }) => {
    return dispatch("request", {
      action: "tracker/list",
      params: {
        clones_filter: "exclude_clones"
      }
    });
  },

  async getHistoryType({ dispatch }) {
    try {
      const result = await dispatch("request", {
        root: "list",
        panel: false,
        action: "history/type/list"
      });

      return result;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async reportGpsHistory(
    { dispatch, commit, state },
    { dateFrom, dateTo, historyType }
  ) {
    if (dateFrom === undefined || dateTo === undefined) {
      return false;
    }

    try {
      let result = [];
      const users = await dispatch("getUserList");

      for (let i = 0; i < users.list.length; i++) {
        const user = users.list[i];

        const trackers = await dispatch("request", {
          action: "tracker/list",
          params: {
            user_id: user.id
          }
        });

        const tracker_ids = trackers.list.map((tracker) => tracker.id);

        if (tracker_ids.length > 0) {
          const history = await dispatch("request", {
            root: "list",
            panel: false,
            action: "history/tracker/list",
            user_id: user.id,
            params: {
              from: state.f,
              to: state.t,
              trackers: tracker_ids,
              ascending: false,
              events: [historyType]
            }
          });

          if (history.length > 0) {
            result.push(...history);
          }
        }
      }

      commit("tracker_history", result);

      return result;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async reportGps({ dispatch, commit }) {
    try {
      /**
       * Estados de conexion
       * {
       * 	active: 0,
       * 	idle: 0,
       * 	offline: 0,
       * 	signal_lost: 0,
       *	just_registered: 0
       * }
       */
      const trackers = await dispatch("getTrackers");
      commit("total_gps", trackers.count);
      const users = await dispatch("getUserList");
      commit("total_users", users.count);

      let statusTracking = {
        active: new Set(),
        idle: new Set(),
        offline: new Set(),
        signal_lost: new Set(),
        just_registered: new Set()
      };

      let groupTrackerByUserId = {};

      trackers.list.forEach((tracker) => {
        if (statusTracking[tracker.source.connection_status] === undefined) {
          statusTracking[tracker.source.connection_status] = new Set();
          statusTracking[tracker.source.connection_status].add(tracker.user_id);
        } else {
          statusTracking[tracker.source.connection_status].add(tracker.user_id);
        }

        if (groupTrackerByUserId[tracker.user_id] === undefined) {
          groupTrackerByUserId[tracker.user_id] = {
            active: 0,
            idle: 0,
            offline: 0,
            signal_lost: 0,
            just_registered: 0
          };

          groupTrackerByUserId[tracker.user_id].user_id = tracker.user_id;
          groupTrackerByUserId[tracker.user_id].user_id = tracker.user_id;

          if (groupTrackerByUserId[tracker.user_id]["trackers"] === undefined) {
            groupTrackerByUserId[tracker.user_id]["trackers"] = [];
            groupTrackerByUserId[tracker.user_id]["trackers"].push(tracker);
          } else {
            groupTrackerByUserId[tracker.user_id]["trackers"].push(tracker);
          }

          if (
            groupTrackerByUserId[tracker.user_id][
              tracker.source.connection_status
            ] === undefined
          ) {
            groupTrackerByUserId[tracker.user_id][
              tracker.source.connection_status
            ] = 1;
          } else {
            groupTrackerByUserId[tracker.user_id][
              tracker.source.connection_status
            ] += 1;
          }
        } else {
          if (
            groupTrackerByUserId[tracker.user_id][
              tracker.source.connection_status
            ] === undefined
          ) {
            groupTrackerByUserId[tracker.user_id][
              tracker.source.connection_status
            ] = 1;
          } else {
            groupTrackerByUserId[tracker.user_id][
              tracker.source.connection_status
            ] += 1;
          }

          if (groupTrackerByUserId[tracker.user_id]["trackers"] === undefined) {
            groupTrackerByUserId[tracker.user_id]["trackers"] = [];
            groupTrackerByUserId[tracker.user_id]["trackers"].push(tracker);
          } else {
            groupTrackerByUserId[tracker.user_id]["trackers"].push(tracker);
          }
        }
      });

      users.list.forEach((user) => {
        if (groupTrackerByUserId[user.id] !== undefined) {
          const total_gpsa = trackers.list.filter((t) => t.user_id === user.id);

          groupTrackerByUserId[
            user.id
          ].name = `${user.first_name} ${user.middle_name} ${user.last_name}`;
          groupTrackerByUserId[user.id].original = user;
          groupTrackerByUserId[user.id].original_trackers = total_gpsa;
          groupTrackerByUserId[user.id].total_gps = total_gpsa.length;
        }
      });

      commit("sum_status_by_user", {
        active: Array.from(statusTracking.active),
        idle: Array.from(statusTracking.idle),
        offline: Array.from(statusTracking.offline),
        just_registered: Array.from(statusTracking.just_registered),
        signal_lost: Array.from(statusTracking.signal_lost)
      });
      return Object.values(groupTrackerByUserId);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  switchUserToGps: async ({ dispatch }, { tracker_id, user_id }) => {
    try {
      const response = await dispatch("request", {
        action: "tracker/move",
        params: {
          user_id: user_id,
          tracker_id: tracker_id
        }
      });

      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  registerTracker: async ({ dispatch }, { tracker, user_id }) => {
    try {
      const {
        label,
        group_id,
        model,
        plugin_id,
        device_id,
        phone,
        activation_code
      } = tracker;

      const response = await dispatch("request", {
        panel: false,
        user_id: user_id,
        params: {
          label: label,
          phone: phone,
          model: model,
          device_id: device_id,
          group_id: group_id ?? 0,
          plugin_id: plugin_id ?? 44,
          activation_code: activation_code ?? null
        }
      });

      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  activeGpsDemo: ({ dispatch }, { tracker }) => {
    return dispatch("registerTracker", {
      tracker: tracker,
      user_id: USER_ID_NAVIXY_DEMO
    });
  },
  reportGpsByUser: ({ dispatch, commit }, { sid }) => {
    return new Promise((resolve, reject) => {
      dispatch("request", {
        action: "tracker/list",
        params: {
          user_id: sid
        }
      })
        .then((data) => {
          commit("total_gps_by_user", data.count);
          commit("list_by_user", data.list);
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  reportGps12H: async ({ dispatch, commit, state }, { sid }) => {
    try {
      commit("RESET_HISTORY");
      // const now = new Date();

      // Valida si el evento del historial es de tipo off
      // y agregalo a la lista negra.
      const validateHistory = (tracker, history) => {
        if (history && black_list.includes(history.event)) {
          // const cEvent = new Date(history.time);
          // let differenceTime = now.getTime() - cEvent.getTime();
          // let differenceHours = (differenceTime / (1000 * 3600 * 24)) * 24;

          commit("ADD_HISTORY", {
            key: "blackTrackers",
            item: tracker
          });
          commit("ADD_HISTORY", {
            key: "eventCollection",
            item: history
          });
          // if (differenceHours >= hoursPassed) {
          // }
        }
      };

      let to = new Date();
      let from = new Date();
      from.setDate(to.getDay() - limitHistoyRange);

      const response = await dispatch("request", {
        action: "tracker/list",
        params: {
          user_id: sid
        }
      });

      commit("total_gps_by_user", response.count);
      commit("list_by_user", response.list);

      // list de gps offline del usuario
      const tracker_ids = response.list
        .filter((f) => {
          return f.source.connection_status === "offline";
        })
        .map((m) => m.id);

      if (tracker_ids.length === 0) {
        return Promise.resolve(true);
      }

      // buscar el historial del gps
      const history = await dispatch("getHistoryBy", {
        to: to,
        from: from,
        tracker_ids: tracker_ids
      });

      // Filtra los gps que solo son de evento off
      let dTracker = {};
      tracker_ids.forEach(async (tracker_id) => {
        dTracker[tracker_id] = history.filter(
          (f) => f.tracker_id === tracker_id && black_list.includes(f.event)
        );
      });

      let dTrackerList = Object.keys(dTracker);

      dTrackerList.forEach(async (tracker_id) => {
        let tracker = state.list_by_user.find(
          (f) => f.id === parseInt(tracker_id)
        );
        let creation_date = new Date(tracker.creation_date);
        let historys = dTracker[tracker_id];

        // Si no tiene historial entonces entramos al bucle de busqueda.
        if (historys.length === 0) {
          // Es necesario resetear la fecha para el nuevo ciclo.
          to = new Date();
          from = new Date();
          from.setDate(to.getDay() - limitHistoyRange);

          let finished = false;
          const loop = async () => {
            try {
              const inner = async () => {
                if (!finished) {
                  historys = await dispatch("getHistoryBy", {
                    to: to,
                    from: from,
                    tracker_ids: [tracker_id]
                  });

                  if (
                    historys.length > 0 ||
                    from.getTime() <= creation_date.getTime()
                  ) {
                    // validad si el ultimo evento es de tipo off
                    validateHistory(tracker, historys[0]);

                    finished = true;
                    return Promise.resolve(true);
                  } else {
                    // siguiente fecha
                    from.setDate(from.getDay() - limitHistoyRange);
                    to.setDate(to.getDay() - limitHistoyRange);

                    return inner();
                  }
                }
              };

              await inner();
            } catch (error) {
              return Promise.reject(error);
            }
          };
          await loop();
        } else {
          // validad si el ultimo evento es de tipo off
          validateHistory(tracker, historys[0]);
        }
      });

      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  getHistoryBy: ({ dispatch }, { from, to, tracker_ids }) => {
    return new Promise((resolve, reject) => {
      dispatch("request", {
        root: "list",
        panel: false,
        action: "history/tracker/list",
        params: {
          from: formatDate(new Date(from), "YYYY-MM-DD hh:mm:ss"),
          to: formatDate(new Date(to), "YYYY-MM-DD hh:mm:ss"),
          ascending: false,
          trackers: tracker_ids
        }
      })
        .then((data) => {
          resolve(data);
        })
        .catch((error) => reject(error));
    });
  },
  getUserNotContract: async ({ dispatch, commit }) => {
    // MIGRADO
    try {
      const users = await dispatch("getUserList");
      const codes = await api
        .get("/api/contracts/allClientNavision?status=")
        .then((resp) => resp.data);
      const listCodes = codes.map((m) => m.ClientCode.trim().toLowerCase());

      let report = [];
      let qtyEquipment = 0;
      for (const user of users.list) {
        if (Object.hasOwnProperty.call(user, "post_region")) {
          const userPostRegion = user.post_region.trim().toLowerCase();

          if (
            userPostRegion === "" ||
            userPostRegion === null ||
            userPostRegion.length <= 0
          ) {
            qtyEquipment += user.trackers_count;
            report.push(user);
            continue;
          }

          if (userPostRegion.substring(0, 2) !== "cl") {
            qtyEquipment += user.trackers_count;
            report.push(user);
            continue;
          }

          if (!listCodes.includes(userPostRegion)) {
            report.push(user);
            continue;
          }
        }
      }

      commit("SET_REPORT_USER_NOT_CONTRACT", report);
      commit("SET_QTY_OF_EQUIPMENT_WITHOUT_CONTRACT", qtyEquipment);

      return report;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  getNaviNavixyDiff: async ({ dispatch, commit }) => {
    try {
      const users = await dispatch("getUserList");
      const codes = await api
        .get("/api/contracts/allClientNavision?status=")
        .then((resp) => resp.data);

      // Estructura de report
      // [
      //  {
      //    code: 'CL0001',
      //    children: [
      //      {
      //        ClientCode: 'CL0001',
      //        Name: 'Nombre 01'
      //      },
      //      {
      //        ClientCode: 'CL0001',
      //        Name: 'Nombre 02'
      //      }
      //    ]
      //  }
      // ]
      let report = [];
      let qtyDiff = 0;
      let takeDiff = 0;
      for (const user of users.list) {
        for (const nav of codes) {
          if (nav.ClientCode.includes(user.post_region)) {
            // valida si ya el codigo existe enel reporte
            const r = report.find((f) => f.code.includes(user.post_region));

            const trackersByUser = await dispatch("request", {
              action: "tracker/list",
              panel: false,
              user_id: user.id
            });
            const cloneQty = trackersByUser.list.filter(
              (f) => f.clone === true
            ).length;
            const ut = user.trackers_count - cloneQty;

            takeDiff = nav.Quantity - ut;

            if (r) {
              // si existe entonces agregalo
              if (takeDiff != 0) {
                if (!r.children) {
                  r.children = [];
                }

                r.children.push({
                  ClientCode: nav.ClientCode,
                  Name: nav.Name,
                  Quantity: nav.Quantity,
                  post_region: user.post_region,
                  first_name: user.first_name,
                  trackers_count: ut,
                  NavNavDiff: takeDiff,
                  No_Contrato: nav.No_Contrato,
                  cloneQty: cloneQty
                });

                qtyDiff = qtyDiff + takeDiff;
                break;
              }
            } else {
              // crealo en el report
              if (takeDiff != 0) {
                report.push({
                  code: user.post_region,
                  ClientCode: nav.ClientCode,
                  Name: nav.Name,
                  Quantity: nav.Quantity,
                  post_region: user.post_region,
                  first_name: user.first_name,
                  trackers_count: ut,
                  NavNavDiff: takeDiff,
                  No_Contrato: nav.No_Contrato,
                  cloneQty: cloneQty
                });

                qtyDiff = qtyDiff + takeDiff;
                break;
              }
            }
          }
        }
      }

      commit("SET_REPORT_USER_NOT_CONTRACT2", report);
      commit("SET_QTY_OF_EQUIPMENT_NAVNAV", qtyDiff);

      return report;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  set_total_gps_by_user_to_default: ({ commit }) => {
    commit("set_total_gps_by_user_to_default");
  },
  ObtainActualUserList: async ({
    /*dispatch,*/ commit,
    /*state,*/ getters
  }) => {
    await axios
      .post(BASE_NAVIXY_API_PANEL_URL + "user/list", {
        hash: await getters.getActualhash
      })
      .then((resp) => {
        //console.log("Respuesta en el action de users: ", resp);
        commit("Set_ActualUserList", resp.data.list);
      })
      .catch((error) => {
        this.$message({
          showClose: true,
          message:
            "Ocurrio un error al consultar la Lista de Usuarios en Navixy: \n" +
            error,
          type: "error"
        });
      });
  },

  async ObtainActualUserInfo(
    { state, getters, commit /*, dispatch*/ },
    ClientCode,
    callbackUserNoFound /*thisvue*/
  ) {
    /*
    console.log(
      "ClientCode: ",
      ClientCode,
      "\n ObtainActualUserInfo ActualUserId: ",
      getters.getActualUserId(ClientCode)
    );
    */
    await axios
      .post(BASE_NAVIXY_API_PANEL_URL + "user/read", {
        hash: state.Actualhash,
        user_id: getters.getActualUserId(ClientCode)
      })
      .then((resp) => {
        //console.log("Respuesta en el action de user info: ", resp);
        let UserInfo = resp.data;
        UserInfo.hash = state.Actualhash;
        UserInfo.user = UserInfo.value;
        delete UserInfo.value;
        //console.log("User info: ", UserInfo);
        commit("Set_ActualUserInfo", UserInfo);
        //dispatch('UpdateNavixyUserActivated', UserInfo)
      })
      .catch((error) => {
        callbackUserNoFound(error);

        vue.$message({
          showClose: true,
          message:
            "Ocurrio un error al consultar la Lista de Usuarios en Navixy: \n" +
            error,
          type: "error"
        });
      });
  },

  async UpdateNavixyUserActivated({ /* state,*/ getters }) {
    /*
    console.log(
      "UpdateNavixyUserActivated userInfo: ",
      getters.getActualUserInfo
    );
    */
    /*
    let params = {
      hash: state.Actualhash,
    }
    */

    let udated = Boolean;
    let userInfo = getters.getActualUserInfo;
    userInfo.user.activated = false;
    await axios
      .post(
        BASE_NAVIXY_API_PANEL_URL + "user/update",
        getters.getActualUserInfo
      )
      .then((resp) => {
        //console.log("respuesta del update: ", resp);
        udated = resp.data.success;
      })
      .catch((err) => {
        console.error("Error: ", err);
      })
      .finally(() => {});
    //console.log("el updated en navixy:  ", udated);
    return udated;
  },

  async updateNavixyUser(
    { dispatch /*, state*/ },
    ClientCode,
    callbackUserNoFound /*thisvue*/
  ) {
    let udated = Boolean;
    await dispatch("getUserList");
    //console.log("hash", state.Actualhash);

    await dispatch("ObtainActualUserList");
    await dispatch(
      "ObtainActualUserInfo",
      ClientCode,
      callbackUserNoFound /*thisvue*/
    );
    udated = await dispatch("UpdateNavixyUserActivated");
    return udated;
  }
};

const mutations = {
  loading: (state) => {
    state.status = "loading";
  },
  success: (state) => {
    state.status = "success";
  },
  error: (state) => {
    state.status = "error";
  },
  list: (state, data) => {
    state.list = data;
  },
  list_by_user: (state, data) => {
    state.list_by_user = data;
  },
  token: (state, token) => {
    state.token = token;
  },
  current_user: (state, current_user) => {
    state.current_user = current_user;
  },
  model_list: (state, model_list) => {
    state.model_list = model_list;
  },
  total_gps: (state, payload) => {
    state.total_gps = payload;
  },
  total_gps_by_user: (state, payload) => {
    state.total_gps_by_user = payload;
  },
  set_trackers: (state, payload) => {
    state.trackers = payload;
  },
  sum_status_by_user: (state, payload) => {
    state.sum_status_by_user = payload;
  },
  total_users: (state, payload) => {
    state.total_users = payload;
  },
  usersToken: (state, payload) => {
    const { user_id, token } = payload;
    if (state.usersToken[user_id] === undefined) {
      state.usersToken[user_id] = token;
    } else {
      state.usersToken[user_id] = token;
    }
  },
  tracker_history: (state, payload) => {
    state.tracker_history = payload;
  },
  f: (state, payload) => {
    state.f = payload;
  },
  t: (state, payload) => {
    state.t = payload;
  },
  ADD_HISTORY: (state, payload) => {
    const { key, item } = payload;
    state.current_user[key].push(item);
  },
  RESET_HISTORY: (state) => {
    state.current_user.eventCollection = [];
    state.current_user.blackTrackers = [];
  },
  SET_REPORT_USER_NOT_CONTRACT: (state, report) => {
    state.reportUserNotContract = report;
  },
  SET_USER_LIST: (state, users) => {
    state.userList = users;
  },
  SET_QTY_OF_EQUIPMENT_WITHOUT_CONTRACT: (state, qty) => {
    state.qtyOfEquipmentWithoutContract = qty;
  },
  SET_REPORT_USER_NOT_CONTRACT2: (state, report) => {
    state.reportUserNotContract2 = report;
  },
  SET_QTY_OF_EQUIPMENT_NAVNAV: (state, qty) => {
    state.qtyOfEquipmentWiNAVNAV = qty;
  },
  set_total_gps_by_user_to_default: () => {
    state.total_gps_by_user = 0;
  },
  Set_Actualhash: (state, hash) => {
    state.Actualhash = hash;
  },
  Set_ActualUserList: (state, userList) => {
    state.ActualUserList = userList;
  },
  Set_ActualUserInfo: (state, userInfo) => {
    state.ActualUserInfo = userInfo;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
